/* ==========================================================================
   PDP Guided Wizard - liquid glass step flow inside the sticky bar
   Drives the REAL page controls (size pills, name/number inputs, patch pills,
   addon cards) then clicks #add-to-cart, so all existing bundle / pricing /
   cart-drawer logic is reused untouched. Reads real DOM only - no Liquid.
   Shared across product-v2 / v3 / v4.
   ========================================================================== */
(function () {
  'use strict';
  if (window.PDPWizard) return;

  var ICON = {
    size: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h18M3 7v10M21 7v10M3 17h18M7 7v3M11 7v5M15 7v3M19 7v5"/></svg>',
    name: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7V5h16v2M9 20h6M12 5v15"/></svg>',
    patch: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 2 2.9 6 6.6.5-5 4.3 1.6 6.4L12 16l-6.1 3.2L7.5 12.8l-5-4.3L9.1 8Z"/></svg>',
    kit: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 4h12l3 4-4 2v10H7V10L3 8Z"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5L20 6"/></svg>'
  };

  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  var STATE = { built: false, idx: 0, steps: [], sheet: null, backdrop: null, done: false };

  /* ---- Which steps does this product support? ---- */
  function detectSteps() {
    var out = [];
    if ($all('.pdp2__pill-row.size-selector .pdp2-pill').length) {
      out.push({ key: 'size', title: 'איזו מידה?', sub: 'בחרו את המידה שלכם', icon: ICON.size, required: true });
    }
    if ($('#line-item-name')) {
      out.push({ key: 'name', title: 'שם ומספר על החולצה?', sub: 'הדפסה חינם - אפשר גם לדלג', icon: ICON.name, required: false });
    }
    if ($all('#metafield-patches .pdp2-pill').length) {
      out.push({ key: 'patch', title: 'להוסיף פאץ׳ ליגה?', sub: 'הסמל הרשמי על השרוול', icon: ICON.patch, required: false });
    }
    if ($all('.pdp2__addon-grid .pdp2-addon-card').length) {
      out.push({ key: 'addon', title: 'להשלים את הסט?', sub: 'פריטים תואמים במחיר מוזל', icon: ICON.kit, required: false });
    }
    return out;
  }

  function available() {
    var atc = $('#add-to-cart');
    if (!atc || atc.disabled) return false;
    return detectSteps().length > 0;
  }

  /* ---- Completion signals (drive dots + summary) ---- */
  function isDone(key) {
    if (key === 'size') {
      if ($('.pdp2__pill-row.size-selector .pdp2-pill.active')) return true;
      var a = $('#add-to-cart');
      return !!a && a.getAttribute('data-needs-size') !== 'true';
    }
    if (key === 'name') { var n = $('#line-item-name'); return !!(n && n.value.trim()); }
    if (key === 'patch') return !!$('#metafield-patches .pdp2-pill.active');
    if (key === 'addon') return !!$('.pdp2__addon-grid .pdp2-addon-card.active');
    return false;
  }

  /* ---- Build the sheet DOM once ---- */
  function build() {
    if (STATE.built) return;
    STATE.backdrop = el('div', 'pdp2__wiz-backdrop');
    STATE.backdrop.id = 'pdp-wiz-backdrop';
    STATE.backdrop.addEventListener('click', close);

    var sheet = el('div', 'pdp2__wiz-sheet');
    sheet.id = 'pdp-wiz';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'התאמת המוצר');
    sheet.innerHTML =
      '<div class="pdp2__wiz-grip"></div>' +
      '<div class="pdp2__wiz-head">' +
        '<button type="button" class="pdp2__wiz-back" aria-label="חזרה">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg>' +
        '</button>' +
        '<div class="pdp2__wiz-dots" id="pdp-wiz-dots"></div>' +
        '<button type="button" class="pdp2__wiz-close" aria-label="סגירה">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
        '</button>' +
      '</div>' +
      '<div class="pdp2__wiz-headline"><span class="pdp2__wiz-ic" id="pdp-wiz-ic"></span>' +
        '<div><div class="pdp2__wiz-title" id="pdp-wiz-title"></div><div class="pdp2__wiz-sub" id="pdp-wiz-sub"></div></div>' +
      '</div>' +
      '<div class="pdp2__wiz-body" id="pdp-wiz-body"></div>' +
      '<div class="pdp2__wiz-foot">' +
        '<button type="button" class="pdp2__wiz-skip" id="pdp-wiz-skip">דלג</button>' +
        '<button type="button" class="pdp2__wiz-next" id="pdp-wiz-next">המשך</button>' +
      '</div>' +
      '<button type="button" class="pdp2__wiz-escape" id="pdp-wiz-escape">מעדיפים לבחור למעלה? לעריכה המלאה ↑</button>';

    document.body.appendChild(STATE.backdrop);
    document.body.appendChild(sheet);
    STATE.sheet = sheet;

    $('.pdp2__wiz-back', sheet).addEventListener('click', prev);
    $('.pdp2__wiz-close', sheet).addEventListener('click', close);
    $('#pdp-wiz-skip', sheet).addEventListener('click', next);
    $('#pdp-wiz-next', sheet).addEventListener('click', next);
    $('#pdp-wiz-escape', sheet).addEventListener('click', escapeUp);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sheet.classList.contains('open')) close(); });

    STATE.built = true;
  }

  /* ---- Step renderers ---- */
  var BODY = function () { return $('#pdp-wiz-body'); };

  function renderSize(body) {
    var row = el('div', 'pdp2__wiz-chips');
    $all('.pdp2__pill-row.size-selector .pdp2-pill').forEach(function (pill) {
      if (pill.classList.contains('disabled')) return;
      var c = el('button', 'pdp2__wiz-chip', pill.textContent.trim());
      c.type = 'button';
      c.dataset.value = pill.dataset.value || '';
      if (pill.classList.contains('active')) c.classList.add('active');
      c.addEventListener('click', function () {
        pill.click();
        $all('.pdp2__wiz-chip', row).forEach(function (x) { x.classList.remove('active'); });
        c.classList.add('active');
        refreshFoot();
        setTimeout(next, 320); // auto-advance once size chosen
      });
      row.appendChild(c);
    });
    body.appendChild(row);
  }

  function renderName(body) {
    var real = $('#line-item-name'), realNum = $('#line-item-number');
    var wrap = el('div', 'pdp2__wiz-name');
    wrap.innerHTML =
      '<label class="pdp2__wiz-field"><span>שם</span>' +
        '<input type="text" id="pdp-wiz-name" inputmode="text" autocomplete="off" maxlength="20" placeholder="לדוגמה: MESSI" style="text-transform:uppercase"></label>' +
      '<label class="pdp2__wiz-field pdp2__wiz-field--num"><span>מספר</span>' +
        '<input type="text" id="pdp-wiz-num" inputmode="numeric" autocomplete="off" maxlength="3" placeholder="10"></label>';
    body.appendChild(wrap);
    var wn = $('#pdp-wiz-name', wrap), wnum = $('#pdp-wiz-num', wrap);
    if (real && real.value) wn.value = real.value;
    if (realNum && realNum.value) wnum.value = realNum.value;
    wn.addEventListener('input', function () {
      this.value = this.value.toUpperCase();
      if (real) { real.value = this.value; real.dispatchEvent(new Event('input', { bubbles: true })); }
      refreshFoot();
    });
    wnum.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '').slice(0, 3);
      if (realNum) { realNum.value = this.value; realNum.dispatchEvent(new Event('input', { bubbles: true })); }
      refreshFoot();
    });
    setTimeout(function () { try { wn.focus({ preventScroll: true }); } catch (e) {} }, 250);
  }

  function renderClones(body, selector, kind) {
    var grid = el('div', 'pdp2__wiz-opts');
    $all(selector).forEach(function (real) {
      if (real.classList.contains('disabled')) return;
      var opt = el('button', 'pdp2__wiz-opt');
      opt.type = 'button';
      var img = real.querySelector('img');
      var title = kind === 'patch'
        ? (real.textContent.trim().split('\n')[0] || 'פאץ׳')
        : ((real.querySelector('.pdp2-addon-card__title') || {}).textContent || '').trim();
      var price = kind === 'patch'
        ? ((real.querySelector('.pdp2-pill__price') || {}).textContent || '').trim()
        : ((real.querySelector('.pdp2-addon-card__price') || {}).textContent || '').trim();
      opt.innerHTML =
        '<span class="pdp2__wiz-opt-media">' + (img ? '<img src="' + img.src + '" alt="" loading="lazy">' : ICON[kind === 'patch' ? 'patch' : 'kit']) + '</span>' +
        '<span class="pdp2__wiz-opt-txt"><span class="pdp2__wiz-opt-title">' + (title || '') + '</span>' +
        (price ? '<span class="pdp2__wiz-opt-price">' + price + '</span>' : '') + '</span>' +
        '<span class="pdp2__wiz-opt-check">' + ICON.check + '</span>';
      if (real.classList.contains('active')) opt.classList.add('active');
      opt.addEventListener('click', function () {
        if (kind === 'addon') {
          var input = real.querySelector('.pdp2-addon-card__input');
          if (input) input.click(); else real.click();
        } else {
          real.click();
        }
        setTimeout(function () {
          opt.classList.toggle('active', real.classList.contains('active'));
          refreshFoot();
        }, 30);
      });
      grid.appendChild(opt);
    });
    body.appendChild(grid);
  }

  function priceText() {
    // Read the computed total but drop the struck compare-at price
    var src = $('#sticky-price') || $('.pdp2__running-price .pdp2__running-num');
    if (!src) return '';
    var clone = src.cloneNode(true);
    $all('.pdp2__addon-compare', clone).forEach(function (n) { n.parentNode.removeChild(n); });
    return (clone.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function renderSummary(body) {
    var total = priceText();
    var chosen = [];
    var sz = $('.pdp2__pill-row.size-selector .pdp2-pill.active');
    if (sz) chosen.push('מידה ' + sz.textContent.trim());
    var nm = $('#line-item-name'), nn = $('#line-item-number');
    if (nm && nm.value.trim()) chosen.push('שם: ' + nm.value.trim() + (nn && nn.value.trim() ? ' ' + nn.value.trim() : ''));
    $all('#metafield-patches .pdp2-pill.active').forEach(function (p) { chosen.push((p.textContent.trim().split('\n')[0]) || 'פאץ׳'); });
    $all('.pdp2__addon-grid .pdp2-addon-card.active').forEach(function (a) { chosen.push(((a.querySelector('.pdp2-addon-card__title') || {}).textContent || '').trim()); });
    var list = el('div', 'pdp2__wiz-summary');
    list.innerHTML = chosen.map(function (t) {
      return '<span class="pdp2__wiz-sum-chip">' + ICON.check + t + '</span>';
    }).join('') || '<span class="pdp2__wiz-sum-chip">מוכן להזמנה</span>';
    body.appendChild(list);
    if (total) {
      var t = el('div', 'pdp2__wiz-total', '<span>סה״כ</span><strong>' + total.trim() + '</strong>');
      body.appendChild(t);
    }
  }

  /* ---- Navigation ---- */
  function stepAt(i) { return STATE.steps[i]; }

  function renderStep() {
    build();
    var st = stepAt(STATE.idx);
    var body = BODY();
    body.innerHTML = '';
    $('#pdp-wiz-ic').innerHTML = st.icon || '';
    $('#pdp-wiz-title').textContent = st.title;
    $('#pdp-wiz-sub').textContent = st.sub || '';
    $('.pdp2__wiz-back').style.visibility = STATE.idx > 0 ? 'visible' : 'hidden';

    if (st.key === 'size') renderSize(body);
    else if (st.key === 'name') renderName(body);
    else if (st.key === 'patch') renderClones(body, '#metafield-patches .pdp2-pill', 'patch');
    else if (st.key === 'addon') renderClones(body, '.pdp2__addon-grid .pdp2-addon-card', 'addon');
    else if (st.key === 'summary') renderSummary(body);

    renderDots();
    refreshFoot();
    body.scrollTop = 0;
  }

  function renderDots() {
    var wrap = $('#pdp-wiz-dots');
    wrap.innerHTML = '';
    STATE.steps.forEach(function (s, i) {
      var d = el('span', 'pdp2__wiz-dot');
      if (i === STATE.idx) d.classList.add('current');
      else if (i < STATE.idx || (s.key !== 'summary' && isDone(s.key))) d.classList.add('done');
      wrap.appendChild(d);
    });
  }

  function refreshFoot() {
    var st = stepAt(STATE.idx);
    var skip = $('#pdp-wiz-skip'), nextBtn = $('#pdp-wiz-next');
    var last = STATE.idx === STATE.steps.length - 1;
    skip.hidden = st.required || st.key === 'summary';
    if (st.key === 'summary') {
      nextBtn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg> הוספה לעגלה';
      nextBtn.classList.add('pdp2__wiz-next--add');
    } else {
      nextBtn.textContent = last ? 'סיום' : 'המשך';
      nextBtn.classList.remove('pdp2__wiz-next--add');
    }
    // block "המשך" on required-size until chosen
    if (st.key === 'size') nextBtn.disabled = !$('.pdp2__pill-row.size-selector .pdp2-pill.active');
    else nextBtn.disabled = false;
  }

  function next() {
    var st = stepAt(STATE.idx);
    if (st.key === 'size' && !$('.pdp2__pill-row.size-selector .pdp2-pill.active')) {
      var chips = $('.pdp2__wiz-chips');
      if (chips) { chips.classList.add('pdp2-shake'); setTimeout(function () { chips.classList.remove('pdp2-shake'); }, 500); }
      return;
    }
    if (st.key === 'summary') { finishAdd(); return; }
    if (STATE.idx < STATE.steps.length - 1) { STATE.idx++; renderStep(); }
    else finishAdd();
  }

  function prev() { if (STATE.idx > 0) { STATE.idx--; renderStep(); } }

  var SCROLL_TARGET = {
    size: '.pdp2__pill-row.size-selector', name: '#print-toggle',
    patch: '#metafield-patches', addon: '.pdp2__addon-grid'
  };
  function escapeUp() {
    var st = stepAt(STATE.idx);
    var sel = SCROLL_TARGET[st.key];
    close();
    if (sel) {
      var t = $(sel);
      if (t) {
        setTimeout(function () {
          t.scrollIntoView({ behavior: 'smooth', block: 'center' });
          t.classList.add('pdp2-pulse');
          setTimeout(function () { t.classList.remove('pdp2-pulse'); }, 1600);
        }, 260);
      }
    }
  }

  function finishAdd() {
    STATE.done = true;
    close();
    setTimeout(function () {
      var atc = $('#add-to-cart');
      if (atc) atc.click();
    }, 220);
  }

  /* ---- Open / close ---- */
  function firstIncomplete() {
    for (var i = 0; i < STATE.steps.length; i++) {
      var s = STATE.steps[i];
      if (s.key === 'summary') break;
      if (s.required && !isDone(s.key)) return i;
    }
    return 0;
  }

  function open() {
    var steps = detectSteps();
    if (!steps.length) { var a = $('#add-to-cart'); if (a) a.click(); return; }
    steps.push({ key: 'summary', title: 'הכל מוכן!', sub: 'עברו על הבחירות והוסיפו לעגלה', icon: ICON.check });
    STATE.steps = steps;
    build();
    STATE.idx = firstIncomplete();
    renderStep();
    requestAnimationFrame(function () {
      STATE.backdrop.classList.add('open');
      STATE.sheet.classList.add('open');
    });
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    if (!STATE.sheet) return;
    STATE.sheet.classList.remove('open');
    STATE.backdrop.classList.remove('open');
    document.documentElement.style.overflow = '';
  }

  window.PDPWizard = { available: available, open: open, close: close };
})();
